import { Select } from "melco-ui";
import { useTranslation } from "react-i18next";
import { LocaleStringCultureCode } from "../../../helper/localestringHelper";
import { useGetAllCultures } from "../../../hooks/localestrings/useGetAllCultures";


type CultureCodeFilterProps = {
  onChange: (value: LocaleStringCultureCode) => void;
  value?: LocaleStringCultureCode;
};

export const CultureCodeFilter: React.FC<CultureCodeFilterProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation();

  const cultures = useGetAllCultures();
  
  const cultureCodeOptions = cultures?.data?.map(
    ({code, name}) => ({
      value: code,
      label: name + " ("+code+")",
    })
  );

  return (
    <Select
     // mode="multiple"
      allowClear
      placeholder={t("localestrings.filter.culturecode.placeholder")}
      style={{ width: "100%", minWidth: 150 }}
      maxTagCount={1}
      options={cultureCodeOptions}
      onChange={onChange}
      value={value}
    />
  );
};
